import { Fragment, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import Loading from "../../skeleton/loading";
import DefaultTextarea from "../../inputs/defaultTextarea";
import DefaultButton from "../../buttons/defaultButton";
import { useDispatch } from "react-redux";
import { _transformPayload } from "../../../../utils/common";
// Note: _fetchClasses import removed as class functionality is not available for HR management system
import { useNavigate } from "react-router-dom";
import DefaultInput from "../../inputs/defaultInput";
import moment from "moment";
import { createReminder } from "../../../../services/workspace/reminder.service";
import { dateFormat } from "../../../../utils/helper";
import DefaultDatePicker from "../../inputs/defaultDatePicker";

const validationSchema = Yup.object().shape({
    name: Yup.string().trim().required("Name is required"),
    time: Yup.string().trim().required("Schedule Time is required"),
    tag: Yup.string().max(20, "Tag must not exceed 20 characters").trim(),
    link: Yup.string().trim(),
    description: Yup.string()
        .max(300, "Description must not exceed 300 characters")
        .trim()
        .required("Description is required"),
    date: Yup.string()
        .trim()
        .required("Schedule date is required")
        .test("isValidDate", "Invalid date format, expected YYYY-MM-DD", (value) =>
            moment(value, "YYYY-MM-DD", true).isValid()
        ),
});

const AddReminderForm = ({
    id,
    isModal = false,
    onClose = () => null,
    updateData = () => null,
    data = null,
}) => {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const {
        handleSubmit,
        handleChange,
        handleBlur,
        setFieldValue,
        values,
        touched,
        errors,
    } = useFormik({
        initialValues: {
            name: "",
            time: "",
            tag: "",
            link: "",
            description: "",
            date: data?.date || dateFormat(new Date()),
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
    setIsSubmitting(true);

    // Fix time format: ensure H:i:s (HH:mm:ss)
    const formattedTime = moment(values.time, "HH:mm").format("HH:mm:ss");

    const payload = _transformPayload({
        ...values,
        time: formattedTime,
    });

    createReminder(payload)
        .then((response) => {
            toast.success("Reminder create successfully!");
            onClose();
            updateData(payload);
        })
        .catch((error) => {
            toast.error(
                "Failed to create reminder! " + error.response?.data?.message
            );
        })
        .finally(() => {
            setIsSubmitting(false);
        });
},

    });

    return (
        <Fragment>
            {loading ? (
                <Loading />
            ) : (
                <div className="flex flex-col w-full gap-4 bg-white rounded-md ">
                    <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                        <div className="grid grid-cols-2 gap-4">

                            <div className="col-span-2">
                                <DefaultInput
                                    label={"Name"}
                                    name="name"
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.name && errors.name ? errors.name : ""}
                                    required
                                />
                            </div>

                            {isModal ? null :
                                <DefaultDatePicker
                                    label="Schedule Date"
                                    name="date"
                                    onChange={(date) => setFieldValue("date", date)}
                                    value={values.date}
                                    placeholder="Schedule Date"
                                    onBlur={handleBlur}
                                    disabled={isModal}
                                    error={touched.date && errors.date ? errors.date : ""}
                                    required
                                />
                            }

                            <DefaultInput
                                label={"Schedule Time"}
                                value={values.time}
                                name={"time"}
                                onChange={handleChange}
                                type="time"
                                className="bg-white border border-transparent hover:border-borderColor"
                                error={
                                    touched.time && errors.time
                                        ? errors.time
                                        : false
                                }
                                required
                            />

                            <DefaultInput
                                label={"Tag"}
                                name="tag"
                                value={values.tag}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.tag && errors.tag ? errors.tag : ""}
                            />
                            <div className="col-span-2">
                                <DefaultInput
                                    label={"Quick Link"}
                                    name="link"
                                    value={values.link}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={touched.link && errors.link ? errors.link : ""}
                                />
                            </div>
                        </div>

                        <div>
                            <DefaultTextarea
                                required
                                label="Description"
                                name="description"
                                placeholder="Enter description here"
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.description && errors.description
                                    ? errors.description
                                    : ""
                                }
                            />
                        </div>
                        <div className="flex items-center gap-2">
                            <DefaultButton
                                variant="default"
                                name={"Submit"}
                                type="submit"
                                loading={isSubmitting}
                            />
                            {isModal ?
                                <DefaultButton
                                    variant="secondary"
                                    name="Cancel"
                                    onClick={onClose}
                                /> : null}
                        </div>
                    </form>
                </div>
            )}
        </Fragment>
    );
};

export default AddReminderForm;